const grey = '#808080';
const lightGrey = '#c4c4c4';

const medBlue = '#00b4d1';
const darkBlue = '#007c90';

// const teal = '#007c90'
const teal1 = '#43bbaa'
const teal2 = '#4bafa2'
const teal3 = '#349f92'
const teal4 = '#378f89'
const teal5 = '#2f7e73'

const orange1 = '#e09264'
const orange2 = '#f0a274'
const orange3 = '#f0b284'
const orange4 = '#f0c294'
const orange5 = '#f0d2a4'

// export
exports.grey = grey;
exports.lightGrey = lightGrey;

exports.medBlue = medBlue;
exports.darkBlue = darkBlue;

// exports.teal = teal;

exports.teal1 = teal1;
exports.teal2 = teal2;
exports.teal3 = teal3;
exports.teal4 = teal4;
exports.teal5 = teal5;

exports.orange1 = orange1;
exports.orange2 = orange2;
exports.orange3 = orange3;
exports.orange4 = orange4;
exports.orange5 = orange5;
